import React from 'react'
import styles from './ReportsReport.css'
import ReportFile from '../../containers/ReportFile'

class ReportsReport extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      match,
      setInitialReportsReportData,
    } = this.props
    setInitialReportsReportData(match)
  }

  render() {
    const {
      handleOnReportsNavClick,
      getReportsReportData,
    } = this.props

    return (
      <div data-page="reports-report" className={styles.reportsReport}>
        <ReportFile
          getPrerequisiteData={getReportsReportData}
          handleOnAllReportsRedirect={() => handleOnReportsNavClick(false, true)}
          showViewPatientOption={true}
        />
      </div>
    )
  }
}

export default ReportsReport



// WEBPACK FOOTER //
// ./src/legacy/pages/ReportsReport/ReportsReport.jsx